import { useState } from 'react';
import Image from 'next/future/image';

import dynamic from 'next/dynamic';
import chevronRight from '@/public/icons/product/chevronRight.svg';
import { ReplacedProduct } from '@/lib/collections/catalogue/helpers';
import { ShippingData } from './types';
import { ProductDetails } from '@/components/products/PurchaseLinks';

const ProductInfoPanel = dynamic(() => import('../ProductInfoPanel'), {
  ssr: false,
});

export default function ProductInfoBox(props: {
  comparePrice?: number;
  price?: number;
  variantId: number;
  productId: number;
  warranty: number | null;
  shippingData: ShippingData;
  deliverBy?: { min: string; max: string };
  subsidyTag?: string;
  isOutOfStock?: boolean;
  upgradation?: string;
  vendor: string;
  offer?: ReplacedProduct;
  productDetails?: ProductDetails;
  category: string;
  categorySummary?: string;
  categoryPk: string;
}) {
  const [show, setShow] = useState(false);

  return (
    <div className="mb-4 cursor-pointer rounded-b-md bg-white sm:mt-0 sm:block sm:cursor-pointer sm:bg-white">
      <div
        className="flex justify-between rounded-b-md border border-gray-200 bg-white px-3 py-4 pt-2 xxs:px-4 xxs:py-5 sm:border sm:border-gray-200 sm:bg-white sm:px-7 sm:py-5"
        onClick={() => {
          setShow(!show);
        }}
      >
        <p className="mt-2 justify-start text-xs font-bold text-gray-700 xxs:mt-0 sm:text-sm">
          Certified Quality & Packaging
        </p>
        <div className="relative flex items-center justify-end px-3">
          <div
            className="mt-2 h-[9px] w-[6px] xxs:mt-0"
            onClick={() => setShow(!show)}
          >
            <Image
              src={chevronRight}
              alt="expand"
              width={6}
              height={9}
              className="h-full w-full"
            />
          </div>
        </div>
      </div>
      {props?.categorySummary && (
        <ProductInfoPanel
          show={show}
          onClose={() => setShow(!show)}
          offer={props.offer}
          warranty={props.warranty}
          shippingData={props.shippingData}
          deliverBy={props.deliverBy}
          category={props.category}
          comparePrice={props.comparePrice}
          price={props.price}
          vendor={props.vendor}
          subsidyTag={props.subsidyTag}
          productId={props.productId}
          variantId={props.variantId}
          upgradation={props.upgradation}
          productDetails={props.productDetails}
          isOutOfStock={props.isOutOfStock}
          categorySummary={props.categorySummary}
          categoryPk={props.categoryPk}
        />
      )}
    </div>
  );
}
